import axios from 'axios';
import { REQUEST_TYPES } from '../../constants/generic-constants';
import { getCookie, removeAppCookies } from '../../utils/cookies-util';
import { userType } from '../../utils';
const TIMEOUT = 90 * 1000;

export default class NetworkManager {
  static getHeaders() {
    const one_signal_id = getCookie('one_signal_id');
    return {
      authorization: `${userType() === 'user' ? getCookie('access-token-user') : getCookie('access-token')}`,
      ...(one_signal_id ? { one_signal_id } : {}),
    };
  }
  static performRequest({ url, data, type, signal, params, responseType }) {
    let config = {
      method: type,
      url: url,
      data: data,
      params: params,
      headers: NetworkManager.getHeaders(),
      ...(signal ? { signal: signal } : {}),
      timeout: TIMEOUT,
    };

    if (responseType) {
      config['responseType'] = responseType;
    }
    return new Promise((resolve, reject) => {
      axios(config)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log('Error:- ', error);
          if (error.response?.status === 403) {
            const status = error.response?.status;
            reject({ status, error });
          } else if ((error.response?.status === 401 && type === REQUEST_TYPES.GET) || type === REQUEST_TYPES.PATCH) {
            removeAppCookies(userType() === 'user');
            window.location.reload();
            reject(error);
            return;
          } else if (error?.response?.status === 502) {
            reject({ message: error?.response?.statusText ?? 'Bad Gateway' });
          } else {
            reject(error);
          }
        });
    });
  }

  static performExternalRequest({ url, data, type, signal, params, headers = {} }) {
    let config = {
      method: type,
      url: url,
      data: data,
      params: params,
      headers: headers,
      ...(signal ? { signal: signal } : {}),
    };

    return new Promise((resolve, reject) => {
      axios(config, {
        timeout: TIMEOUT,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error.response?.status === 403) {
            const status = error.response?.status;
            reject({ status, error });
          } else if (error?.response?.status === 502) {
            reject({ message: error?.response?.statusText ?? 'Bad Gateway' });
          } else {
            reject(error);
          }
        });
    });
  }
}
